const getUserLocation = async () => {
  try {
    const userCoordinates = (await getUserCoordinatesByIP()) || null;

    if (!userCoordinates) {
      throw new Error("Not able to get user Location");
    }
    const userLocationInfos = await getUserLocationInfos(userCoordinates);
    return { ...userLocationInfos, source: "IP" };
  } catch (e) {
    console.error(e);
  }
};

const getUserCoordinatesByIP = async () => {
  console.log("Trying using IP");
  try {
    const response = await fetch(
      "https://ipgeolocation.abstractapi.com/v1/?api_key=fdc42eba2f604b60a2a5af2f8d8f68d2"
    );
    if (response.ok) {
      const data = await response.json();
      const { longitude, latitude } = data;
      return { longitude, latitude };
    } else {
      throw new Error("Something went wrong");
    }
  } catch (e) {
    console.error(e);
  }
};
const askForUserGeoLocation = async () => {
  throw new Error("DEPRECATED");
  try {
    const options = {
      enableHighAccuracy: true,
      timeout: 2000,
      maximumAge: 0,
    };
    const pos = await new Promise((resolve, reject) => {
      const success = async (e) => {
        const mealPlanSession = JSON.parse(
          localStorage.getItem("meal-plan-session")
        );
        if (mealPlanSession && mealPlanSession.geolocation !== undefined) {
          const location = await getUserLocationInfos({
            longitude: e.coords.longitude,
            latitude: e.coords.latitude,
          });
          mealPlanSession.geolocation = { ...location, source: "GPS" };
          localStorage.setItem(
            "meal-plan-session",
            JSON.stringify(mealPlanSession)
          );
        }
        resolve();
      };
      const denied = (e) => {
        console.error(e);
        reject(e);
      };
      navigator.geolocation.getCurrentPosition(success, denied, options);
    });
    return {
      latitude: pos?.coords.latitude,
      longitude: pos?.coords.longitude,
    };
  } catch (e) {
    console.error(e);
    return null;
  }
};

const getUserLocationInfos = async (userCoordinates) => {
  try {
    const { latitude, longitude } = userCoordinates;
    const apiKey = "B6VSqXRE8HW42z5AJv89Jv2BewdDZCNfON4iKcv7QVw";
    const baseURL = "https://revgeocode.search.hereapi.com/v1/revgeocode?";
    const response = await fetch(
      `${baseURL}at=${latitude},${longitude}&show=streetInfo&limit=1&apiKey=${apiKey}`
    );
    if (response.ok) {
      const data = await response.json();
      const position = data.items[0].position;
      const address = data.items[0].address;
      return { ...position, ...address };
    } else {
      throw new Error("Something went wrong");
    }
  } catch (e) {
    console.error(e);
  }
};
